module.exports = __webpack_public_path__ + "static/media/indiepin_tutorial.4d7a8c13.gif";